<app-chat-box [key]="'lodger'"></app-chat-box>
